import { gql } from "@apollo/client";
import { errorFragment, contactFragment } from "./fragment";

export const CREATE_CONTACT = gql`
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      contact {
        ...contactFragment
      }
      errors {
        ...errorFragment
      }
    }
  }
  ${errorFragment}
  ${contactFragment}
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      contact {
        ...contactFragment
      }
      errors {
        ...errorFragment
      }
    }
  }
  ${errorFragment}
  ${contactFragment}
`;
